import React from 'react';
import { Box, Chip } from '@mui/material';
import SearchableSelect from '../common/SearchableSelect';
import { TaxCodeLookup, TaxCodeLookupItem } from '../../interfaces/indirectTax.interface';
import { selectableCodes } from './useTaxCodeLookup';
import { helpElement } from '../../help/attrs';

interface Props {
  lookup: TaxCodeLookup | null;
  side: 'OUTPUT' | 'INPUT';
  value: string | null | undefined;
  onChange: (taxCodeId: string | null, item: TaxCodeLookupItem | null) => void;
  disabled?: boolean;
  'data-testid'?: string;
  /** Help-mode key, put on the picker's root so a form can explain it. */
  'data-help'?: string;
}

const TaxCodeSelect: React.FC<Props> = ({ lookup, side, value, onChange, disabled, ...rest }) => {
  const options = selectableCodes(lookup, side, value);
  const labelOf = (c: TaxCodeLookupItem) =>
    `${c.code} — ${c.summary || `${c.effectiveRatePct}%`}${c.id === lookup?.exportCodeId ? ' (Export)' : ''}${c.active ? '' : ' (inactive)'}`;
  return (
    <Box sx={{ minWidth: 190 }}>
      <SearchableSelect<TaxCodeLookupItem>
        size="small"
        label="Tax code"
        placeholder="No code (free rate)"
        options={options}
        value={value ?? ''}
        onChange={(id, item) => onChange(id || null, item)}
        getOptionLabel={labelOf}
        disabled={disabled}
        data-testid={rest['data-testid']}
        {...helpElement(rest['data-help'])}
        renderOption={(props, c) => (
          <li {...props} key={c.id}>
            {c.code} — {c.summary || `${c.effectiveRatePct}%`}
            {c.id === lookup?.exportCodeId && <Chip size="small" label="Export" sx={{ ml: 1 }} />}
            {!c.active && <Chip size="small" label="Inactive" sx={{ ml: 1 }} />}
          </li>
        )}
      />
    </Box>
  );
};

export default TaxCodeSelect;
